const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  if (item.attribute_key === 'content') {
    const values = item.values || '';
    return values.split(',');
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

// The backend consumes `custom_attribute_type` as the attribute MODEL
// (`conversation_attribute` / `contact_attribute`) and falls back to the
// service default when it is empty (see FilterService#custom_attribute). The
// applied filter, however, carries the attribute's DISPLAY type in this field
// (text, list, checkbox, …) so the URL encoder can namespace the filter as
// `custom__<key>__<op>__<type>`. A display type must never reach the backend:
// it would be looked up as a non-existent model and the custom filter would
// silently stop matching. Keep a real model value; otherwise send it empty and
// let the service resolve its own default model.
const BACKEND_ATTRIBUTE_MODELS = new Set([
  'conversation_attribute',
  'contact_attribute',
]);

const backendCustomAttributeType = value => {
  // Preserve absent values (undefined/null/'') as-is so payloads that never
  // carried a custom attribute type — e.g. automation conditions on standard
  // attributes — keep their original shape and let the service resolve its
  // default model. Only a truthy DISPLAY type (text, list, …) is coerced to ''.
  if (!value) return value;
  return BACKEND_ATTRIBUTE_MODELS.has(value) ? value : '';
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    // If item key is content, we will split it using comma and return as array
    // FIX ME: Make this generic option instead of using the key directly here
    return {
      attribute_key: item.attribute_key,
      // Routing flag consumed by FilterHelper#custom_attribute_row? (backend)
      // to send a custom attribute keyed like a built-in one (status/city/…)
      // through the custom path instead of the built-in one (#1288/#1298).
      // Passed through as-is: absent/'standard' keeps built-in behavior,
      // 'custom_attributes' forces the custom path. Distinct from
      // custom_attribute_type below, which carries the attribute MODEL used
      // by automation rules and by the custom query itself.
      attribute_model: item.attribute_model,
      custom_attribute_type: backendCustomAttributeType(
        item.custom_attribute_type
      ),
      filter_operator: item.filter_operator,
      values: generateValues(item),
      query_operator: item.query_operator,
    };
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
